module.exports = __webpack_public_path__ + "img/empty-cart.0b52f65e.svg";